import type { MatchState, PlayerState } from "@arcade-hockey/sim";

// Find the nearest opposing skater to `player`. Returns null if no opposing
// player exists (e.g. all opponents are filtered out for some reason).
// Caller owns the returned reference — do not mutate.
export function nearestOpponentTo(
  player: PlayerState,
  state: MatchState,
): { opponent: PlayerState; distance: number } | null {
  let best: PlayerState | null = null;
  let bestDist = Number.POSITIVE_INFINITY;
  for (const candidate of state.players) {
    if (candidate.teamId === player.teamId) continue;
    const dx = candidate.pos.x - player.pos.x;
    const dy = candidate.pos.y - player.pos.y;
    const d = Math.hypot(dx, dy);
    if (d < bestDist) {
      bestDist = d;
      best = candidate;
    }
  }
  return best === null ? null : { opponent: best, distance: bestDist };
}

// Squared distance between two players. Use this for ranking when the actual
// magnitude doesn't matter — saves the sqrt in inner loops.
export function distanceSquared(a: PlayerState, b: PlayerState): number {
  const dx = a.pos.x - b.pos.x;
  const dy = a.pos.y - b.pos.y;
  return dx * dx + dy * dy;
}
